const FormActions = ({ children }: { children: React.ReactNode }) => {
  return <div className="mt-8">{children}</div>
}

export default FormActions
